import { useState } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';
import { useAuth } from '../context/AuthContext';

const API = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const experts = [
  {
    init:'SA', color:'#6366f1',
    name:'Safder Abbas',
    role:'Founder & Lead Consultant',
    country:'🇵🇰 Pakistan',
    university:'University of Karachi',
    degree:'Masters holder',
    expertIn:['European Universities','Germany','Netherlands'],
    specialties:['DAAD','Chevening','Erasmus'],
    bio:'Founder of FindAScholars with extensive experience helping students secure admissions and scholarships at top European universities. Personally reviewed 1,000+ applications.',
    email:'tomika.findascholars@gmail.com',
    years:'5+ years',
  },
  {
    init:'DM', color:'#10b981',
    name:'David Max',
    role:'PhD Application Expert',
    country:'🇩🇪 Germany',
    university:'TU Munich',
    degree:'PhD holder',
    expertIn:['Germany','Austria','Switzerland'],
    specialties:['DAAD','TU Munich','RWTH Aachen'],
    bio:'PhD graduate from TU Munich with deep expertise in German university admissions, DAAD scholarships, and professor outreach for research positions in DACH region.',
    email:'davidmax.findascholars@gmail.com',
    years:'6+ years',
  },
  {
    init:'DM', color:'#e85d9a',
    name:'David Morrison',
    role:'Scholarship Specialist',
    country:'🇸🇪 Sweden',
    university:'KTH Royal Institute of Technology',
    degree:'Masters holder',
    expertIn:['Sweden','Nordic Countries','Erasmus'],
    specialties:['Swedish Institute','Erasmus Mundus','KTH'],
    bio:'Masters graduate from KTH with expertise in Swedish Institute scholarships, Nordic university applications, and Erasmus Mundus programs across Europe.',
    email:'david.findascholars@gmail.com',
    years:'4+ years',
  },
  {
    init:'TO', color:'#f59e0b',
    name:'Tommy Oho',
    role:'UK & US Application Expert',
    country:'🇬🇧 United Kingdom',
    university:'University of Oxford',
    degree:'PhD holder',
    expertIn:['UK','USA','Canada'],
    specialties:['Chevening','Fulbright','Rhodes'],
    bio:'PhD from Oxford with comprehensive knowledge of UK, US and Canadian university admissions. Expert in Chevening and Fulbright scholarship applications.',
    email:'tommy.findascholars@gmail.com',
    years:'7+ years',
  },
  {
    init:'TY', color:'#3b82f6',
    name:'Thomas Yacoob',
    role:'CV & SOP Writing Expert',
    country:'🇳🇱 Netherlands',
    university:'TU Delft',
    degree:'Masters holder',
    expertIn:['CV Writing','SOP','Netherlands'],
    specialties:['NFP','Orange Knowledge','TU Delft'],
    bio:'Professional academic writer with 500+ successful CVs and SOPs reviewed. Masters from TU Delft with expertise in Netherlands and Belgian scholarships.',
    email:'thomas.findascholars@gmail.com',
    years:'4+ years',
  },
  {
    init:'YZ', color:'#ef4444',
    name:'Yolanda Zaw',
    role:'Professor Outreach Coach',
    country:'🇦🇺 Australia',
    university:'University of Melbourne',
    degree:'Masters holder',
    expertIn:['Professor Emails','Australia','New Zealand'],
    specialties:['Australia Awards','Email Strategy','Research Positions'],
    bio:'Masters from University of Melbourne. Developed a proven professor outreach strategy with 70%+ reply rate. Expert in Australian scholarship applications.',
    email:'yolanda.findascholar@gmail.com',
    years:'3+ years',
  },
  {
    init:'JA', color:'#8b5cf6',
    name:'Josh Andreson',
    role:'European Masters Expert',
    country:'🇧🇪 Belgium',
    university:'Ghent University',
    degree:'Masters holder',
    expertIn:['Belgium','France','Italy'],
    specialties:['Erasmus Mundus','VLIR-UOS','Eiffel'],
    bio:'Masters from Ghent University with expertise in Belgian, French and Italian university applications. Helped 200+ students secure Erasmus Mundus scholarships.',
    email:'josh.findascholar@gmail.com',
    years:'4+ years',
  },
  {
    init:'GV', color:'#06b6d4',
    name:'Gabriela Virgen',
    role:'Asian Universities Expert',
    country:'🇨🇳 China',
    university:'Tsinghua University',
    degree:'PhD holder',
    expertIn:['China','Japan','South Korea'],
    specialties:['CSC Scholarship','MEXT','KGSP'],
    bio:'PhD from Tsinghua University with deep expertise in Chinese, Japanese and Korean university applications and government scholarship programs.',
    email:'gabriela.findascholar@gmail.com',
    years:'5+ years',
  },
  {
    init:'SG', color:'#059669',
    name:'Simon George',
    role:'Interview Preparation Coach',
    country:'🇨🇦 Canada',
    university:'University of Toronto',
    degree:'Masters holder',
    expertIn:['Interview Prep','Canada','USA'],
    specialties:['Chevening Interview','Fulbright Interview','Scholarship Interviews'],
    bio:'Chevening and Fulbright scholar with expertise in scholarship interview preparation. Helped 300+ students crack competitive scholarship interviews worldwide.',
    email:'george.findascholars@gmail.com',
    years:'5+ years',
  },
];

const officeCard = {
  tagline:'Helping students achieve their academic dreams since 2014',
  description:'For over 10 years, FindAScholars has been the trusted platform for international students seeking PhD supervisors and scholarships. From a small team of passionate scholars, we have grown into a global community serving students from 150+ countries.',
  email:'contact@findascholars.com',
  linkedin:'https://linkedin.com/company/findascholars',
  stats:[
    { val:'10+',     label:'Years of Experience', icon:'🏆' },
    { val:'50,000+', label:'Students Helped',      icon:'🎓' },
    { val:'500K+',   label:'Professor Profiles',   icon:'👨‍🏫' },
    { val:'10,000+', label:'Scholarships Listed',  icon:'📚' },
    { val:'150+',    label:'Countries Covered',    icon:'🌍' },
    { val:'95%',     label:'Success Rate',         icon:'⭐' },
  ],
  achievements:[
    '✅ Reviewed 100,000+ scholarship applications since 2014',
    '✅ Partnered with 500+ universities worldwide',
    '✅ Trusted by students from Pakistan, India, Bangladesh, Nigeria & 150+ more countries',
    '✅ Featured in Dawn, Tribune, and international education media',
    '✅ Maintained 4.8/5 average student satisfaction rating',
  ],
  officeDetails:{
    hours:'Mon–Fri, 9am–6pm GMT',
    location:'London, United Kingdom',
    response:'Within 24 hours',
  },
};

export default function ExpertPage({ requireUpgrade, requireLogin }) {
  const { user }      = useAuth();
  const [hoveredId,   setHoveredId]   = useState(null);
  const [waLoading,   setWaLoading]   = useState(false);

  const isPaid = user && user.plan && user.plan !== 'free';

  // ── WhatsApp — backend se milega (sirf premium) ───────────
  const handleWhatsApp = async () => {
    if (!user)   { requireLogin   && requireLogin();   return; }
    if (!isPaid) { requireUpgrade && requireUpgrade(); return; }

    setWaLoading(true);
    try {
      const token = localStorage.getItem('fas_token');
      const res   = await axios.get(`${API}/contact/whatsapp`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      window.open(res.data.link, '_blank');
    } catch (err) {
      if (err.response?.data?.message === 'upgrade_required') {
        requireUpgrade && requireUpgrade();
      } else {
        toast.error('Could not load WhatsApp. Try again.');
      }
    }
    setWaLoading(false);
  };

  return (
    <div style={{background:'#060b14',minHeight:'calc(100vh - 68px)',padding:'40px 32px',fontFamily:'Inter,sans-serif'}}>

      {/* ── Header ── */}
      <div style={{textAlign:'center',marginBottom:'48px'}}>
        <span style={{display:'inline-block',fontSize:'12px',fontWeight:'600',color:'#818cf8',textTransform:'uppercase',letterSpacing:'2px',background:'rgba(99,102,241,0.1)',padding:'6px 16px',borderRadius:'20px',marginBottom:'16px'}}>
          Expert Team
        </span>
        <h1 style={{fontFamily:'Space Grotesk,sans-serif',fontSize:'38px',fontWeight:'700',color:'#f1f5f9',marginBottom:'12px',letterSpacing:'-0.5px'}}>
          Meet Our Experts
        </h1>
        <p style={{fontSize:'16px',color:'#64748b',maxWidth:'560px',margin:'0 auto',lineHeight:1.7}}>
          Real people who have been through the process — here to guide your academic journey across 150+ countries.
        </p>
        {!isPaid && (
          <div style={{display:'inline-flex',alignItems:'center',gap:'8px',marginTop:'16px',background:'rgba(245,158,11,0.1)',border:'1px solid rgba(245,158,11,0.25)',borderRadius:'20px',padding:'8px 18px'}}>
            <span style={{fontSize:'14px'}}>💬</span>
            <span style={{fontSize:'12px',color:'#fbbf24',fontWeight:'500'}}>
              WhatsApp access available on <strong>Premium plan</strong>
            </span>
          </div>
        )}
      </div>

      {/* ── 9 Expert Cards ── */}
      <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:'22px',maxWidth:'1200px',margin:'0 auto 48px'}}>
        {experts.map((expert, idx) => {
          const isHovered = hoveredId === idx;
          return (
            <div key={idx}
              onMouseEnter={() => setHoveredId(idx)}
              onMouseLeave={() => setHoveredId(null)}
              style={{
                background:'rgba(255,255,255,0.03)', borderRadius:'18px', padding:'26px',
                border:`1px solid ${isHovered ? expert.color : 'rgba(255,255,255,0.08)'}`,
                transition:'all 0.2s',
                transform: isHovered ? 'translateY(-4px)' : 'none',
                boxShadow: isHovered ? `0 8px 32px ${expert.color}25` : 'none',
                display:'flex', flexDirection:'column',
              }}
            >
              {/* Top */}
              <div style={{display:'flex',alignItems:'flex-start',gap:'14px',marginBottom:'16px'}}>
                <div style={{width:'52px',height:'52px',borderRadius:'14px',background:expert.color,color:'#fff',fontWeight:'700',fontSize:'16px',display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}>
                  {expert.init}
                </div>
                <div style={{flex:1,minWidth:0}}>
                  <div style={{fontFamily:'Space Grotesk,sans-serif',fontSize:'15px',fontWeight:'700',color:'#f1f5f9',marginBottom:'3px'}}>{expert.name}</div>
                  <div style={{fontSize:'12px',fontWeight:'600',color:expert.color,marginBottom:'3px'}}>{expert.role}</div>
                  <div style={{fontSize:'11px',color:'#475569'}}>{expert.country}</div>
                </div>
              </div>

              {/* Badges */}
              <div style={{display:'flex',flexWrap:'wrap',gap:'6px',marginBottom:'14px'}}>
                <span style={{fontSize:'11px',fontWeight:'600',background:'rgba(99,102,241,0.15)',color:'#818cf8',border:'1px solid rgba(99,102,241,0.35)',padding:'4px 12px',borderRadius:'20px',whiteSpace:'nowrap'}}>⭐ {expert.years}</span>
                <span title={expert.university} style={{fontSize:'11px',fontWeight:'600',background:`${expert.color}20`,color:expert.color,border:`1.5px solid ${expert.color}50`,padding:'4px 12px',borderRadius:'20px',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap',display:'inline-block',maxWidth:'100%'}}>🎓 {expert.university}</span>
                <span style={{fontSize:'11px',fontWeight:'600',background:'rgba(16,185,129,0.15)',color:'#34d399',border:'1px solid rgba(16,185,129,0.35)',padding:'4px 12px',borderRadius:'20px',whiteSpace:'nowrap'}}>{expert.degree}</span>
              </div>

              {/* Expert in */}
              <div style={{marginBottom:'12px'}}>
                <span style={{fontSize:'12px',color:'#64748b',fontWeight:'600'}}>Expert in: </span>
                <span style={{fontSize:'12px',color:'#94a3b8'}}>{expert.expertIn.join(', ')}</span>
              </div>

              {/* Bio */}
              <p style={{fontSize:'13px',color:'#94a3b8',lineHeight:1.8,margin:'0 0 16px',flex:1}}>{expert.bio}</p>

              {/* Specialties */}
              <div style={{display:'flex',flexWrap:'wrap',gap:'6px',marginBottom:'18px'}}>
                {expert.specialties.map(s=>(
                  <span key={s} style={{fontSize:'11px',fontWeight:'600',background:'rgba(255,255,255,0.06)',color:'#94a3b8',border:'1.5px solid rgba(255,255,255,0.15)',padding:'4px 12px',borderRadius:'20px',whiteSpace:'nowrap'}}>{s}</span>
                ))}
              </div>

              {/* Email button — EVERYONE can email */}
              <div style={{marginTop:'auto'}}>
                <a href={`mailto:${expert.email}`}
                  style={{display:'flex',alignItems:'center',justifyContent:'center',gap:'6px',width:'100%',padding:'10px 14px',background:'rgba(99,102,241,0.12)',border:'1px solid rgba(99,102,241,0.35)',borderRadius:'10px',color:'#818cf8',fontSize:'13px',fontWeight:'600',textDecoration:'none',transition:'all 0.15s',boxSizing:'border-box'}}
                  onMouseEnter={e=>e.currentTarget.style.background='rgba(99,102,241,0.25)'}
                  onMouseLeave={e=>e.currentTarget.style.background='rgba(99,102,241,0.12)'}
                >
                  ✉️ Email {expert.name.split(' ')[0]}
                </a>
              </div>
            </div>
          );
        })}
      </div>

      {/* ── Office Card ── */}
      <div style={{maxWidth:'1200px',margin:'0 auto'}}>
        <div style={{background:'linear-gradient(135deg, rgba(99,102,241,0.1), rgba(16,185,129,0.07))',borderRadius:'24px',padding:'48px',border:'1px solid rgba(99,102,241,0.25)',boxShadow:'0 0 60px rgba(99,102,241,0.08)'}}>

          <div style={{textAlign:'center',marginBottom:'40px'}}>
            <div style={{width:'72px',height:'72px',borderRadius:'20px',background:'linear-gradient(135deg,#6366f1,#10b981)',color:'#fff',fontWeight:'800',fontSize:'18px',display:'flex',alignItems:'center',justifyContent:'center',margin:'0 auto 16px'}}>FAS</div>
            <h2 style={{fontFamily:'Space Grotesk,sans-serif',fontSize:'28px',fontWeight:'700',color:'#f1f5f9',marginBottom:'8px'}}>FindAScholars</h2>
            <p style={{fontSize:'14px',color:'#818cf8',fontWeight:'500',marginBottom:'12px'}}>{officeCard.tagline}</p>
            <p style={{fontSize:'14px',color:'#64748b',maxWidth:'700px',margin:'0 auto',lineHeight:1.8}}>{officeCard.description}</p>
          </div>

          {/* Stats */}
          <div style={{display:'grid',gridTemplateColumns:'repeat(6,1fr)',gap:'16px',marginBottom:'40px'}}>
            {officeCard.stats.map((stat,i)=>(
              <div key={i} style={{textAlign:'center',padding:'20px 12px',background:'rgba(255,255,255,0.04)',borderRadius:'14px',border:'1px solid rgba(255,255,255,0.08)'}}>
                <div style={{fontSize:'24px',marginBottom:'8px'}}>{stat.icon}</div>
                <div style={{fontFamily:'Space Grotesk,sans-serif',fontSize:'22px',fontWeight:'700',color:'#818cf8',lineHeight:1,marginBottom:'6px'}}>{stat.val}</div>
                <div style={{fontSize:'11px',color:'#475569',lineHeight:1.4}}>{stat.label}</div>
              </div>
            ))}
          </div>

          {/* Achievements + Office Details */}
          <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'24px',marginBottom:'36px'}}>
            <div style={{background:'rgba(255,255,255,0.03)',borderRadius:'16px',padding:'24px',border:'1px solid rgba(255,255,255,0.07)'}}>
              <h4 style={{fontFamily:'Space Grotesk,sans-serif',fontSize:'15px',fontWeight:'700',color:'#f1f5f9',marginBottom:'16px'}}>🏅 Our Achievements</h4>
              <div style={{display:'flex',flexDirection:'column',gap:'10px'}}>
                {officeCard.achievements.map((a,i)=>(
                  <div key={i} style={{fontSize:'13px',color:'#94a3b8',lineHeight:1.6,padding:'8px 12px',background:'rgba(99,102,241,0.06)',borderRadius:'8px',border:'1px solid rgba(99,102,241,0.1)'}}>{a}</div>
                ))}
              </div>
            </div>
            <div style={{background:'rgba(255,255,255,0.03)',borderRadius:'16px',padding:'24px',border:'1px solid rgba(255,255,255,0.07)'}}>
              <h4 style={{fontFamily:'Space Grotesk,sans-serif',fontSize:'15px',fontWeight:'700',color:'#f1f5f9',marginBottom:'16px'}}>📍 Office Details</h4>
              <div style={{display:'flex',flexDirection:'column',gap:'10px'}}>
                {[
                  {icon:'🕒',label:'Working Hours', value:officeCard.officeDetails.hours},
                  {icon:'📍',label:'Location',      value:officeCard.officeDetails.location},
                  {icon:'⚡',label:'Response Time', value:officeCard.officeDetails.response},
                  {icon:'📧',label:'Email',         value:officeCard.email},
                ].map(d=>(
                  <div key={d.label} style={{display:'flex',alignItems:'center',gap:'12px',padding:'10px 14px',background:'rgba(255,255,255,0.03)',borderRadius:'10px',border:'1px solid rgba(255,255,255,0.06)'}}>
                    <span style={{fontSize:'16px',flexShrink:0}}>{d.icon}</span>
                    <div>
                      <div style={{fontSize:'10px',color:'#475569',marginBottom:'2px'}}>{d.label}</div>
                      <div style={{fontSize:'13px',fontWeight:'500',color:'#94a3b8'}}>{d.value}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Contact Buttons */}
          <div style={{display:'flex',gap:'12px',justifyContent:'center',flexWrap:'wrap'}}>

            {/* Email — sab ke liye open */}
            <a href={`mailto:${officeCard.email}`}
              style={{padding:'13px 30px',background:'#6366f1',borderRadius:'12px',color:'#fff',fontSize:'14px',fontWeight:'600',textDecoration:'none',display:'flex',alignItems:'center',gap:'7px'}}
              onMouseEnter={e=>e.currentTarget.style.opacity='0.85'}
              onMouseLeave={e=>e.currentTarget.style.opacity='1'}
            >
              ✉️ Email FindAScholars
            </a>

            {/* LinkedIn — sab ke liye */}
            <a href={officeCard.linkedin} target="_blank" rel="noreferrer"
              style={{padding:'13px 30px',background:'rgba(14,165,233,0.1)',border:'1px solid rgba(14,165,233,0.3)',borderRadius:'12px',color:'#38bdf8',fontSize:'14px',fontWeight:'600',textDecoration:'none',display:'flex',alignItems:'center',gap:'7px'}}
              onMouseEnter={e=>e.currentTarget.style.background='rgba(14,165,233,0.2)'}
              onMouseLeave={e=>e.currentTarget.style.background='rgba(14,165,233,0.1)'}
            >
              in Follow on LinkedIn
            </a>

            {/* WhatsApp — sirf premium, number backend se */}
            <button
              onClick={handleWhatsApp}
              disabled={waLoading}
              style={{
                padding:'13px 30px',
                background: isPaid ? 'rgba(37,211,102,0.12)' : 'rgba(245,158,11,0.08)',
                border: `1px solid ${isPaid ? 'rgba(37,211,102,0.3)' : 'rgba(245,158,11,0.25)'}`,
                borderRadius:'12px',
                color: isPaid ? '#25d366' : '#fbbf24',
                fontSize:'14px', fontWeight:'600', cursor:'pointer',
                display:'flex', alignItems:'center', gap:'7px',
                opacity: waLoading ? 0.6 : 1,
                transition:'all 0.2s',
              }}
            >
              {waLoading
                ? '⏳ Loading...'
                : isPaid
                  ? '💬 WhatsApp Us'
                  : '💬 WhatsApp 🔒 Premium Only'
              }
            </button>

          </div>
        </div>
      </div>
    </div>
  );
}